import React from 'react'

import { AnimationFadeIn } from 'shared/Animation/Animation'

interface Datas {
  datas: {
    flamelinkHeroContent: {
      alt: string
      width: number
      height: number
      image: {
        url: string
      }[]
    }
  }
}

const s = {
  container: `absolute top-0 left-0 z-1 w-full h-screen text-white`,
  overlay: `absolute top-0 left-0 z-2 w-full h-full bg-opblack`,
  group: `w-full h-screen flexcenter`,
  image: `w-full h-full object-cover text-transparent transition delay-300 ease-in`,
}

const Image = ({ datas }: Datas) => {
  const { image, alt, width, height } = datas.flamelinkHeroContent

  return (
    <section className={s.container}>
      <AnimationFadeIn delay={50} x={0} y={0}>
        <div
          className={s.overlay}
          style={{ clipPath: 'polygon(0% 0%, 100% 0%, 100% 93%, 0% 100%)' }}
        />

        <div className={s.group}>
          <img
            className={s.image}
            src={image[0].url}
            alt={alt}
            width={width}
            height={height}
            style={{ clipPath: 'polygon(0% 0%, 100% 0%, 100% 93%, 0% 100%)' }}
          />
        </div>
      </AnimationFadeIn>
    </section>
  )
}

export default Image
